var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cinput class=\"datepicker\" type=\"text\" data-bind=\"datePicker:value, format: options.shortDateFormat, culture:options.i18n.culture, css: { error: !isValueValid() }\"\u003E";;return pug_html;};
module.exports = template;